// extracted by mini-css-extract-plugin
export default {"rowWrapper":"quote-freight-port_rowWrapper__RiB4L"};